import Vue from 'vue'
import VueRouter from 'vue-router'
import rpc from '@/auth/rpc/ociRpc'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        requiresLogin: true,
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/',
      name: 'check-in',
      component: () => import('@/views/CheckInOutView.vue'),
      meta: {
        pageTitle: 'Check In',
        requiresLogin: true,
        breadcrumb: [
          {
            text: 'Check In',
            active: true,
          },
        ],
      },
    },
    {
      path: '/check-out',
      name: 'check-out',
      component: () => import('@/views/CheckInOutView.vue'),
      meta: {
        pageTitle: 'Check Out',
        requiresLogin: true,
        breadcrumb: [
          {
            text: 'Check Out',
            active: true,
          },
        ],
      },
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@/views/CheckInOutMap.vue'),
      meta: {
        pageTitle: 'Map',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/views/Projects.vue'),
      meta: {
        pageTitle: 'Projects',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/driverprojects',
      name: 'driverprojects',
      component: () => import('@/views/DriverProjects.vue'),
      meta: {
        pageTitle: 'Driver Projects',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: {
        pageTitle: 'Profile',
        requiresLogin: true,
        breadcrumb: [],
      },
    },    
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/Help.vue'),
      meta: {
        pageTitle: 'Help',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/acceptreject',
      name: 'acceptreject',
      component: () => import('@/views/AcceptRejectView.vue'),
      meta: {
        pageTitle: 'Accept Reject',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/reject',
      name: 'reject',
      component: () => import('@/views/RejectView.vue'),
      meta: {
        pageTitle: 'Reject',
        requiresLogin: true,
        breadcrumb: [],
      },
    },     
    {
      path: '/acceptrejected',
      name: 'acceptrejected',
      component: () => import('@/views/AcceptRejectedView.vue'),
      meta: {
        pageTitle: 'Accept Rejected',
        requiresLogin: true,
        breadcrumb: [],
      },
    },     
    {
      path: '/acceptunaccepted',
      name: 'acceptunaccepted',
      component: () => import('@/views/AcceptUnacceptedView.vue'),
      meta: {
        pageTitle: 'Accept Rejected',
        requiresLogin: true,
        breadcrumb: [],
      },
    },      
    {
      path: '/completed',
      name: 'completed',
      component: () => import('@/views/CompletedView.vue'),
      meta: {
        pageTitle: 'Completed',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/noshow',
      name: 'noshow',
      component: () => import('@/views/NoShowView.vue'),
      meta: {
        pageTitle: 'No Show',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/unabletoattend',
      name: 'unabletoattend',
      component: () => import('@/views/UnableToAttendView.vue'),
      meta: {
        pageTitle: 'Unable to attend',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/job',
      name: 'job',
      component: () => import('@/views/Job.vue'),
      meta: {
        pageTitle: 'Job',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/reason',
      name: 'reason',
      component: () => import('@/views/ReasonView.vue'),
      meta: {
        pageTitle: 'Reason',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: () => import('@/views/CancelSignInView.vue'),
      meta: {
        pageTitle: 'Cancel',
        requiresLogin: true,
        breadcrumb: [],
      },
    },    
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/googletest.vue'),
      meta: {
        pageTitle: 'Test',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/reset-password',
      name: 'reset',
      component: () => import('@/views/ResetPassword.vue'),
      meta: {
        requiresLogin: false,
        layout: 'full',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        requiresLogin: false,
        layout: 'full',
      },
    },
    {
      path: '/ethos',
      name: 'ethos',
      component: () => import('@/views/Ethos.vue'),
      meta: {
        pageTitle: 'Ethos',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/driverprocess',
      name: 'driverprocess',
      component: () => import('@/views/DriverProcessView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/vehicle_reg',
      name: 'vehicle_reg',
      component: () => import('@/views/VehicleRegistrationView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_vehicle_reg',
      name: 'waste_vehicle_reg',
      component: () => import('@/views/driver/waste/WasteVehicleRegistration.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_drive_to',
      name: 'waste_drive_to',
      component: () => import('@/views/driver/waste/WasteDriveTo.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_collection',
      name: 'waste_collection',
      component: () => import('@/views/driver/waste/WasteCollection.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_weight_collected',
      name: 'waste_weight_collected',
      component: () => import('@/views/driver/waste/WasteWeightCollected.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_client_sign',
      name: 'waste_client_sign',
      component: () => import('@/views/driver/waste/WasteClientSign.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_destination',
      name: 'waste_destination',
      component: () => import('@/views/driver/waste/WasteDestination.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_drive_to_2',
      name: 'waste_drive_to_2',
      component: () => import('@/views/driver/waste/WasteDriveTo2.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_confirm_to_drop',
      name: 'waste_confirm_to_drop',
      component: () => import('@/views/driver/waste/WasteConfirmToDrop.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_confirm_waste',
      name: 'waste_confirm_waste',
      component: () => import('@/views/driver/waste/WasteConfirmWaste.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_select_to_drop',
      name: 'waste_select_to_drop',
      component: () => import('@/views/driver/waste/WasteSelectToDrop.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_docket',
      name: 'waste_docket',
      component: () => import('@/views/driver/waste/WasteDocket.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_confirm',
      name: 'waste_confirm',
      component: () => import('@/views/driver/waste/WasteConfirm.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_vehicle_reg',
      name: 'dc_vehicle_reg',
      component: () => import('@/views/driver/dc/DCVehicleRegistration.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_drive_to',
      name: 'dc_drive_to',
      component: () => import('@/views/driver/dc/DCDriveTo.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_confirm_collected',
      name: 'dc_confirm_collected',
      component: () => import('@/views/driver/dc/DCConfirmCollected.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_review_purchase_order',
      name: 'dc_review_purchase_order',
      component: () => import('@/views/driver/dc/DCReviewPurchaseOrder.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_take_photo',
      name: 'dc_take_photo',
      component: () => import('@/views/driver/dc/DCTakePhoto.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_drive_to_2',
      name: 'dc_drive_to_2',
      component: () => import('@/views/driver/dc/DCDriveTo2.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_confirm_delivery',
      name: 'dc_confirm_delivery',
      component: () => import('@/views/driver/dc/DCConfirmDelivery.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_add_details',
      name: 'dc_add_details',
      component: () => import('@/views/driver/dc/DCAddDetails.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_select_rejected',
      name: 'dc_select_rejected',
      component: () => import('@/views/driver/dc/DCSelectRejected.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_add_notes',
      name: 'dc_add_notes',
      component: () => import('@/views/driver/dc/DCAddNotes.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_obtain_signature',
      name: 'dc_obtain_signature',
      component: () => import('@/views/driver/dc/DCObtainSignature.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_po_confirm',
      name: 'dc_po_confirm',
      component: () => import('@/views/driver/dc/DCPOConfirm.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_add_notes_photos',
      name: 'dc_add_notes_photos',
      component: () => import('@/views/driver/dc/DCAddNotesAndPhotos.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/dc_confirm',
      name: 'dc_confirm',
      component: () => import('@/views/driver/dc/DCConfirm.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_col',
      name: 'waste_col',
      component: () => import('@/views/WasteCollectionView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_cli_sign',
      name: 'waste_cli_sign',
      component: () => import('@/views/WasteClientSignView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_dest',
      name: 'waste_dest',
      component: () => import('@/views/WasteDestinationView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_docket',
      name: 'waste_docket',
      component: () => import('@/views/WasteDocketView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/waste_conf',
      name: 'waste_conf',
      component: () => import('@/views/WasteConfirmView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/vehicle_reg_dc',
      name: 'vehicle_reg_dc',
      component: () => import('@/views/DCVehicleRegistrationView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/items_to_deliver_dc',
      name: 'items_to_deliver_dc',
      component: () => import('@/views/DCItemsToDeliverView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/confirm_delivery_dc',
      name: 'confirm_delivery_dc',
      component: () => import('@/views/DCConfirmDeliveryView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/items_to_collect_dc',
      name: 'items_to_collect_dc',
      component: () => import('@/views/DCItemsToCollectView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/confirm_collect_dc',
      name: 'confirm_collect_dc',
      component: () => import('@/views/DCConfirmCollectView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/notes_upload_photo_dc',
      name: 'notes_upload_photo_dc',
      component: () => import('@/views/DCNotesUploadPhotoView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/client_signature_dc',
      name: 'client_signature_dc',
      component: () => import('@/views/DCClientSignatureView.vue'),
      meta: {
        pageTitle: 'Process',
        requiresLogin: true,
        breadcrumb: [],
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        requiresLogin: false,
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    next()
    return
  }
  if (to.matched.some(record => record.meta.requiresLogin)) {
    if (rpc.getToken() !== null && rpc.getToken().length) {
      next()
    } else {
      next({
        name: 'login',
      })
    }
  } else if (to.name === 'reset') {
    next()
  } else {
    next({
      name: 'login',
    })
  }
})

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (from) {
//     // nothing
//   }
//   if (to.name) {
//     // Start the route progress bar.
//     NProgress.start()
//   }
//   next()
// })

// router.afterEach((to, from) => {
//   if (to || from) {
//     // nothing
//   }

//   // Complete the animation of the route progress bar.
//   NProgress.done()
// })

export default router
